<template>
  <div>
    <v-img
      v-if="imageUrl"
      class="align-center text-center template-default-img"
      :src="imageUrl"
      style="border-radius: 15px;"
      cover
      height="166px"
      position="center center">
    </v-img>
  </div>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'templateImage',
  data () {
    return {
      imageUrl: ''
    }
  },
  props: {
    order: {
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'marketingLineTemplateContent'
    ])
  },
  watch: {
    marketingLineTemplateContent () {
      this.initImage()
    }
  },
  destroyed () {
  },
  mounted () {
    this.initImage()
  },
  methods: {
    ...mapMutations([
    ]),
    initImage () {
      if (this.marketingLineTemplateContent[this.order].content) {
        let textContent = this.marketingLineTemplateContent[this.order].content
        this.imageUrl = textContent.imageUrl
      } else {
        this.imageUrl = ''
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/line/components/templateFragments/templateImage.vue